import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Link2, ArrowLeftRight, ShoppingBag } from "lucide-react";
import { api } from "@/lib/api";
import { PillarBadge } from "@/constants/pillars";
import { Button } from "@/components/ui/button";

export default function MatchesPage() {
  const navigate = useNavigate();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/matches/mine").then((r) => { setMatches(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="p-4">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-sm text-neutral-500 mb-3"><ArrowLeft size={18} />Indietro</button>
      <div className="flex items-center gap-2 mb-1">
        <Link2 size={22} />
        <h1 className="font-display text-2xl font-bold">Agganci automatici</h1>
      </div>
      <p className="text-sm text-neutral-500 mb-5">Il software collega automaticamente domanda e offerta compatibili.</p>

      {loading ? <p className="text-center text-neutral-400 py-10 text-sm">Caricamento…</p> :
        matches.length === 0 ? (
          <div className="text-center text-neutral-400 py-14">
            <ArrowLeftRight size={32} className="mx-auto mb-2" />
            <p className="text-sm">Nessun aggancio ancora.</p>
            <p className="text-xs mt-1">Pubblica un'offerta o una richiesta: gli agganci compaiono qui.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {matches.map((m) => {
              const counterpart = m.mine_type === "offer" ? m.request : m.offer;
              return (
                <motion.div key={m.id} data-testid={`match-${m.id}`} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
                  className="border border-neutral-200 rounded-2xl p-4">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-[10px] font-mono uppercase tracking-widest bg-black text-white rounded-full px-2 py-0.5">{m.affinity ?? m.score * 15}% affinità</span>
                    {m.pillar && <PillarBadge id={m.pillar} />}
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div className={`rounded-xl p-3 ${m.mine_type === "offer" ? "bg-neutral-100" : "bg-emerald-50"}`}>
                      <p className="text-[10px] uppercase tracking-wide text-neutral-500 mb-1">{m.mine_type === "offer" ? "La tua offerta" : "Offerta"}</p>
                      <p className="font-semibold text-sm line-clamp-2">{m.offer.title || m.offer.text}</p>
                      {m.offer.price > 0 && <p className="font-display font-bold mt-1">€{Number(m.offer.price).toFixed(2)}</p>}
                    </div>
                    <div className={`rounded-xl p-3 ${m.mine_type === "request" ? "bg-neutral-100" : "bg-orange-50"}`}>
                      <p className="text-[10px] uppercase tracking-wide text-neutral-500 mb-1">{m.mine_type === "request" ? "La tua richiesta" : "Richiesta"}</p>
                      <p className="font-semibold text-sm line-clamp-3">{m.request.title || m.request.text}</p>
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-3">
                    <p className="text-xs text-neutral-500">con <span className="font-semibold text-black">{counterpart?.name}</span></p>
                    {m.offer.offer_id && (
                      <Button data-testid={`match-view-${m.id}`} onClick={() => navigate(`/marketplace/${m.offer.offer_id}`)}
                        className="h-9 rounded-full bg-black text-white text-sm"><ShoppingBag size={14} className="mr-1" />Vedi offerta</Button>
                    )}
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
    </div>
  );
}
